module.exports = __webpack_public_path__ + "static/img/ODS Logo.bb9c9b5.png";